import React, { useEffect, useState } from "react";
import { useStock } from "../StockContext"; // Adjust the path as necessary
import Sidebar from "../partials/Sidebar";
import Header from "../partials/Header";
import AnalyticsCard01 from "../partials/analytics/AnalyticsCard01";
import axios from "axios";
import ModalSearch from "../components/ModalSearch";
import {
  calculateAverageFcfMargin,
  calculateAverageProfitMargin,
  calculateRevGrowthAvg,
  clearInputValues,
  calculateStockValues
} from "../utils/AnayliticsFunctionality";
import { FutureAssumptionsAnalysis } from "../components/FutureAssumptionsAnalysis";
import DropdownFull from "../components/DropdownFull";
import { yearsOfAnalysis } from "../constants";





// ...existing code...
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Analytics Error Boundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 bg-red-50 border border-red-200 rounded-md">
          <h2 className="text-lg font-semibold text-red-700 mb-2">Noget gik galt</h2>
          <p className="text-red-600">Der opstod en fejl ved indlæsning af data. Prøv at:</p>
          <ul className="list-disc list-inside text-red-600 mt-2">
            <li>Vælg en anden aktie</li>
            <li>Opdater siden</li>
            <li>Kontroller din internetforbindelse</li>
          </ul>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Genindlæs siden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function Analytics() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [stockLogo, setStockLogo] = useState(null);
  const { stockSelected1, setStockSelected1 } = useStock();
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [financialData, setFinancialData] = useState(null);
  const [companyInfo, setCompanyInfo] = useState(null);
  const [futurePrices, setFuturePrices] = useState({ low: null, mid: null });

  const [stockPrice, setStockPrice] = useState(null);
  const [selectedYear, setSelectedYear] = useState(10);
  const [selectedAssumptionEntries, setSelectedAssumptionEntries] = useState(2);
  const [currentRevenue, setCurrentRevenue] = useState(null);
  const [peRatios, setPeRatios] = useState({
    peRatio1Year: null,
    peRatio3Years: null,
    inputs: {
      low: "",
      mid: "",
    },
  });
  const [pfcf, setPfcf] = useState({
    firstYearPFCF: "-",
    threeYearPFCF: "-",
    inputs: { low: "", mid: "" },
  });

  const [roe, setRoe] = useState({
    firstYearROE: null,
    inputs: {
      low: "",
    },
  });
  const [revGrowth, setRevGrowth] = useState({
    firstYearRevGrowth: null,
    threeYearRevGrowth: null,
    inputs: {
      low: "",
      mid: "",
    },
  });
  const [profitMargin, setProfitMargin] = useState({
    firstYearProfitMargin: null,
    threeYearProfitMargin: null,
    inputs: {
      low: "",
      mid: "",
    },
  });
  const [fcfMargin, setFcfMargin] = useState({
    firstYearFcfMargin: null,
    threeYearFcfMargin: null,
    inputs: {
      low: "",
      mid: "",
    },
  });
  const [desiredAnualReturn, setDesiredAnualReturn] = useState({
    inputs: {
      low: "",
      mid: "",
    },
  });

  const [closingPrice, setClosingPrice] = useState(null);
  const [currency, setCurrency] = useState(null);

  useEffect(() => {
    clearInputValues(
      setFinancialData,
      setFuturePrices,
      setStockPrice,
      setCurrentRevenue,
      setPeRatios,
      setPfcf,
      setRoe,
      setRevGrowth,
      setProfitMargin,
      setFcfMargin,
      setDesiredAnualReturn
    );


    

    if (stockSelected1 != null) {
      console.log("Stock Selected:", stockSelected1);
      fetch(`https://investorverden.onrender.com/api/financials?q=${stockSelected1.symbol}`)
        .then((res) => res.json())
        .then((data) => {
          setFinancialData(data);
        });

        const fetchCompanyInfo = async () => {
          try {
            console.log("Fetching company info for:", stockSelected1.symbol);
            const response = await axios.get(
              `https://investorverden.onrender.com/api/stocks?q=${stockSelected1.symbol}`
            );
            console.log("Raw company info response:", response.data);
            
            if (response.data && response.data.stockData) {
              const stockData = response.data.stockData;
              console.log("Processed stock data:", stockData);
              setCompanyInfo(stockData);
            } else {
              console.error("Invalid company info format:", response.data);
            }
          } catch (error) {
            console.error("Error fetching company information:", error);
          }
        };

      fetchCompanyInfo();
    }
  }, [stockSelected1]);

  useEffect(() => {
    if (financialData) {
      const { summaryDetail, earnings, financialData: finData } = financialData;

      try {
        setCurrency(finData?.financialCurrency || "$");

        let firstYearPFCF = null;
        let threeYearPFCF = null;
        if (summaryDetail?.marketCap && finData?.freeCashflow) {
          firstYearPFCF = (
            summaryDetail.marketCap / finData.freeCashflow
          ).toFixed(2);
        }
        if (
          earnings?.financialsChart?.yearly?.length >= 3 &&
          summaryDetail?.marketCap
        ) {
          const last3Years = earnings.financialsChart.yearly.slice(-3);
          const avgEarnings =
            last3Years.reduce((acc, year) => acc + (year.earnings || 0), 0) / 3;
          if (avgEarnings > 0) {
            threeYearPFCF = (summaryDetail.marketCap / avgEarnings).toFixed(2);
          }
        }

        let firstYearRevGrowth = null;
        let threeYearRevGrowth = null;
        if (earnings?.financialsChart?.yearly?.length >= 2) {
          const lastTwo = earnings.financialsChart.yearly.slice(-2);
          firstYearRevGrowth = (
            ((lastTwo[1].revenue - lastTwo[0].revenue) /
              lastTwo[0].revenue) *
            100
          ).toFixed(2);
        }
        if (earnings?.financialsChart?.yearly?.length >= 4) {
          const lastFour = earnings.financialsChart.yearly;
          const threeYearGrowth =
            ((lastFour[3].revenue - lastFour[0].revenue) /
              lastFour[0].revenue) *
            100;
          threeYearRevGrowth = (threeYearGrowth / 3).toFixed(2);
        }

        let firstYearProfitMargin = null;
        let threeYearProfitMargin = null;
        if (finData?.profitMargins) {
          firstYearProfitMargin = (finData.profitMargins * 100).toFixed(2);
        }
        if (earnings?.financialsChart?.yearly?.length >= 3) {
          const last3Years = earnings.financialsChart.yearly.slice(-3);
          const avgMargin =
            last3Years.reduce((acc, year) => {
              return acc + (year.earnings / year.revenue || 0);
            }, 0) / 3;
          threeYearProfitMargin = (avgMargin * 100).toFixed(2);
        }

        let firstYearFcfMargin = null;
        let threeYearFcfMargin = null;
        if (finData?.freeCashflow && finData?.totalRevenue) {
          firstYearFcfMargin = (
            (finData.freeCashflow / finData.totalRevenue) *
            100
          ).toFixed(2);
        }
        if (earnings?.financialsChart?.yearly?.length >= 3) {
          const last3Years = earnings.financialsChart.yearly.slice(-3);
          const avgFcfMargin =
            last3Years.reduce((acc, year) => {
              const fcf = year.fcf || 0;
              return acc + (fcf / year.revenue || 0);
            }, 0) / 3;
          threeYearFcfMargin = (avgFcfMargin * 100).toFixed(2);
        }

        setPfcf((prev) => ({
          ...prev,
          firstYearPFCF: firstYearPFCF || "-",
          threeYearPFCF: threeYearPFCF || "-",
        }));
        setRevGrowth((prev) => ({
          ...prev,
          firstYearRevGrowth: firstYearRevGrowth || "-",
          threeYearRevGrowth: threeYearRevGrowth || "-",
        }));
        setProfitMargin((prev) => ({
          ...prev,
          firstYearProfitMargin: firstYearProfitMargin || "-",
          threeYearProfitMargin: threeYearProfitMargin || "-",
        }));
        setFcfMargin((prev) => ({
          ...prev,
          firstYearFcfMargin: firstYearFcfMargin || "-",
          threeYearFcfMargin: threeYearFcfMargin || "-",
        }));

        if (summaryDetail) {
          setClosingPrice(summaryDetail.previousClose || null);
          setCurrency(summaryDetail.currency || "$");
        }

        const firstYearROE = financialData?.financialData?.returnOnEquity
          ? (financialData.financialData.returnOnEquity * 100).toFixed(2)
          : null;
        const firstYearPeRatios = financialData?.summaryDetail?.trailingPE
          ? financialData.summaryDetail.trailingPE.toFixed(2)
          : null;

        setRoe((prev) => ({
          ...prev,
          firstYearROE: firstYearROE || "-",
        }));
        setPeRatios((prev) => ({
          ...prev,
          firstYearPeRatios: firstYearPeRatios || "-",
        }));
      } catch (error) {
        console.error("Error processing financial data:", error);
        setPfcf((prev) => ({ ...prev, firstYearPFCF: "-", threeYearPFCF: "-" }));
        setRevGrowth((prev) => ({ ...prev, firstYearRevGrowth: "-", threeYearRevGrowth: "-" }));
        setProfitMargin((prev) => ({ ...prev, firstYearProfitMargin: "-", threeYearProfitMargin: "-" }));
        setFcfMargin((prev) => ({ ...prev, firstYearFcfMargin: "-", threeYearFcfMargin: "-" }));
        setRoe((prev) => ({ ...prev, firstYearROE: "-" }));
        setPeRatios((prev) => ({ ...prev, firstYearPeRatios: "-" }));
      }
    }
  }, [financialData]);

  const handleAnalyser = (year) => {
    if (!financialData) {
      console.error("No financial data available");
      return;
    }
    
    // Ensure year is correctly set
    setSelectedYear(year);
  
    const sharesOutstanding = financialData?.defaultKeyStatistics?.sharesOutstanding;
    if (!sharesOutstanding) {
      console.error("Missing sharesOutstanding in defaultKeyStatistics");
      return;
    }
  
    const revenue = financialData?.financialData?.totalRevenue;
    if (!revenue) {
      console.error("Missing totalRevenue");
      return;
    }
  
    // Update currentRevenue if not set
    if (!currentRevenue) {
      setCurrentRevenue(revenue);
    }
  
    // Log values for debugging
    console.log({
      years: year,
      revGrowth,
      profitMargin,
      peRatios,
      currentRevenue: revenue,
      sharesOutstanding,
      currentStockPrice: stockPrice
    });
  
    calculateStockValues({
      revGrowth,
      years: year, // Pass the year directly without parsing
      profitMargin,
      peRatios,
      currentRevenue: revenue,
      sharesOutstanding,
      currentStockPrice: stockPrice,
      setFuturePrices,
    });
  };


  

  return (
    <div className="flex h-[100dvh] overflow-hidden">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        <Header
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          onStockSelect={setStockSelected1}
        />
        <ErrorBoundary>
          <ModalSearch
            id="search-modal"
            modalOpen={searchModalOpen}
            setModalOpen={setSearchModalOpen}
            onStockSelect={setStockSelected1}
          />
          <main className="grow">
            <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto space-y-5">
              {/* Header Section */}
              <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <div className="px-5 pt-5">
                  <header className="flex justify-between items-start mb-2">
                  <button
                    onClick={() => setSearchModalOpen(true)}
                    className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2 hover:text-violet-500 dark:hover:text-violet-400 transition-colors"
                  >
                    {companyInfo ? 
                      (companyInfo.shortName || companyInfo.longName || stockSelected1?.symbol || "Vælg en aktie") 
                      : "Vælg en aktie"}
                  </button>
                  </header>
                  <div className="text-3xl font-bold text-gray-800 dark:text-gray-100">
                    {closingPrice} {currency}
                    {companyInfo && (
                      <div className="text-sm text-light-500 dark:text-gray-400">
                        Analysen er basseret på lukkekursen fra i går
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Controls Section */}
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-full xl:col-span-8">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 sm:justify-start gap-5">
                    <div className="space-y-2">
                      <h2 className="text-sm">Hvor mange års analyse?</h2>
                      <DropdownFull
                        options={yearsOfAnalysis}
                        selected={selectedYear}
                        setSelected={setSelectedYear}
                        handleAnalyser={handleAnalyser}
                      />
                    </div>
                    <div className="flex justify-start items-end">
                      <h2 className="text-green-700 text-sm">
                        Påmindelse: Analyseværktøjet <br /> faktor ikke balance sheet med.
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              {/* Main Content Grid */}
              <div className="grid grid-cols-12 gap-6">
                {/* Analytics Card (takes entire width on mobile, 8/12 on md+) */}
                <div className="col-span-12 md:col-span-8">
                  <AnalyticsCard01
                    roe={roe}
                    setRoe={setRoe}
                    revGrowth={revGrowth}
                    setRevGrowth={setRevGrowth}
                    profitMargin={profitMargin}
                    setProfitMargin={setProfitMargin}
                    fcfMargin={fcfMargin}
                    setFcfMargin={setFcfMargin}
                    pe={peRatios}
                    setPeRatios={setPeRatios}
                    pfcf={pfcf}
                    setpfcf={setPfcf}
                    desiredAnualReturn={desiredAnualReturn}
                    setDesiredAnualReturn={setDesiredAnualReturn}
                    handleAnalyser={handleAnalyser}
                    selectedYear={selectedYear}
                    selectedAssumptionEntries={selectedAssumptionEntries}
                  />
                </div>

                {/* Future Assumptions Analysis (stacks below on mobile, side-by-side on md+) */}
                <div className="col-span-12 md:col-span-4">
                  <FutureAssumptionsAnalysis
                    years={yearsOfAnalysis.map((year) => year.id)}
                    revGrowth={revGrowth}
                    profitMargin={profitMargin}
                    fcfMargin={fcfMargin}
                    pe={peRatios}
                    pfcf={pfcf}
                    symbol={stockSelected1?.symbol}
                    desiredAnualReturn={desiredAnualReturn}
                    handleAnalyser={handleAnalyser}
                    selectedYear={selectedYear}
                    setSelectedYear={setSelectedYear}
                    stockPrice={stockPrice}
                    setStockPrice={setStockPrice}
                    currentRevenue={currentRevenue}
                    setCurrentRevenue={setCurrentRevenue}
                    futurePrices={futurePrices}
                    setFuturePrices={setFuturePrices}
                    selectedAssumptionEntries={selectedAssumptionEntries}
                    stockSelected1={stockSelected1}
                    currency={currency}
                  />
                </div>
              </div>
            </div>
          </main>
        </ErrorBoundary>
      </div>
    </div>
  );
}

export default Analytics;